import { ComponentInstance, DismissedComponentsStorage } from '../types';

const filterDismissed = (
  instances: ComponentInstance[],
  componentType: string,
  dismissed: DismissedComponentsStorage
): ComponentInstance[] => {
  const dismissedIds = dismissed[componentType] ?? [];
  if (dismissedIds.length === 0) return instances;
  return instances.filter((instance) => !dismissedIds.includes(instance.id));
};

export default filterDismissed;
